"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Input = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var utilities_1 = require("../../utilities");
var InputAddon_1 = require("./InputAddon");
var __1 = require("../");
var FormField_1 = require("../FormField");
var inputProps_1 = require("./inputProps");
var Children = react_1.default.Children, createElement = react_1.default.createElement, createRef = react_1.default.createRef, cloneElement = react_1.default.cloneElement, isValidElement = react_1.default.isValidElement;
var Input = /** @class */ (function (_super) {
    __extends(Input, _super);
    function Input() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.inputRef = _this.props.inputRef || createRef();
        _this.renderAction = function () {
            var _a = _this.props, action = _a.action, disabled = _a.disabled;
            if (action == null)
                return null;
            if (typeof action === 'string') {
                return (react_1.default.createElement(__1.Button, { disabled: disabled, size: _this.computeSize().inputSize }, action));
            }
            if (action != null && isValidElement(action)) {
                return cloneElement(action, {
                    disabled: disabled,
                    size: _this.computeSize().inputSize,
                });
            }
        };
        _this.renderIcon = function () {
            var _a = _this.props, loading = _a.loading, icon = _a.icon, iconPosition = _a.iconPosition;
            var loadingOverlapsIcon = loading && icon && iconPosition === 'right';
            if (loadingOverlapsIcon) {
                return null;
            }
            if (typeof icon === 'string') {
                return (react_1.default.createElement(__1.Icon, { name: icon, size: _this.computeSize().iconSize }));
            }
            if (icon != null && isValidElement(icon)) {
                return cloneElement(icon, {
                    size: _this.computeSize().iconSize,
                });
            }
            if (icon != null && !isValidElement(icon)) {
                return (react_1.default.createElement(__1.Icon, __assign({}, icon, { style: icon.onClick
                        ? { pointerEvents: 'auto', cursor: 'pointer' }
                        : null })));
            }
            return null;
        };
        // Creating an input element
        _this.renderInput = function (htmlInputProps) {
            var _a = _this.props, input = _a.input, type = _a.type;
            // Handling case of duplicate ID's for the same FormField label
            var isLabelAssigned = _this.context.inputRef;
            var labelFor = _this.context.labelFor;
            if (!isLabelAssigned) {
                _this.context.inputRef = _this.inputRef;
            }
            if (input != null && isValidElement(input)) {
                return cloneElement(input, __assign(__assign({}, htmlInputProps), { id: _this.props.id || (!isLabelAssigned ? labelFor : undefined) }));
            }
            return createElement('input', __assign(__assign({}, htmlInputProps), { type: type, id: _this.props.id || (!isLabelAssigned ? labelFor : undefined) }));
        };
        // Creating an addon
        _this.renderShortLabel = function () {
            var shortLabel = _this.props.shortLabel;
            if (typeof shortLabel === 'string' && shortLabel !== '') {
                return react_1.default.createElement(InputAddon_1.InputAddon, null, shortLabel);
            }
            if (shortLabel != null && isValidElement(shortLabel)) {
                var iconSize = shortLabel.props.size || _this.computeSize().iconSize;
                return (react_1.default.createElement(InputAddon_1.InputAddon, null, cloneElement(shortLabel, { size: iconSize })));
            }
            return null;
        };
        // Handling with size-related shortcut props, like xsmall="true"...
        _this.computeSize = function () {
            var inputSize = _this.props.size;
            if (_this.props.xsmall)
                inputSize = 'xsmall';
            if (_this.props.small)
                inputSize = 'small';
            if (_this.props.large)
                inputSize = 'large';
            var iconSize = {
                xsmall: '16px',
                small: '20px',
                medium: '20px',
                large: '24px',
            }[inputSize];
            return { inputSize: inputSize, iconSize: iconSize };
        };
        _this.computeTabIndex = function () {
            var _a = _this.props, disabled = _a.disabled, tabIndex = _a.tabIndex;
            if (tabIndex != null) {
                return tabIndex;
            }
            if (disabled) {
                return -1;
            }
        };
        _this.focus = function () { return _this.inputRef.current.focus(); };
        _this.select = function () { return _this.inputRef.current.select(); };
        _this.handleChange = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(e, __assign(__assign({}, _this.props), { value: e.target.value }));
            }
        };
        _this.handleChildOverrides = function (child, defaultProps) { return (__assign(__assign(__assign({}, defaultProps), child.props), { ref: function (c) {
                utilities_1.handleRef(child.ref, c);
                _this.inputRef.current = c;
            } })); };
        return _this;
    }
    Input.prototype.render = function () {
        var _a, _b;
        var _this = this;
        var _c = this.props, action = _c.action, actionPosition = _c.actionPosition, children = _c.children, className = _c.className, disabled = _c.disabled, InputElement = _c.el, error = _c.error, fluid = _c.fluid, focus = _c.focus, icon = _c.icon, iconPosition = _c.iconPosition, inverted = _c.inverted, loading = _c.loading, shortLabel = _c.shortLabel, shortLabelPosition = _c.shortLabelPosition, transparent = _c.transparent;
        var _d = this.props, inputRef = _d.inputRef, inputProps = __rest(_d, ["inputRef"]);
        var hideLoading = !loading ||
            !!action ||
            (!!shortLabel && shortLabelPosition === 'right');
        var loadingOverlapsIcon = loading && icon && iconPosition === 'right';
        var InputClasses = classnames_1.default('Input', className, (_a = {},
            _a["Input--" + this.computeSize().inputSize] = this.computeSize().inputSize,
            _a['Input--disabled'] = disabled,
            _a['Input--error'] = error,
            _a['Input--fluid'] = fluid,
            _a['Input--focus'] = focus,
            _a['Input--inverted'] = inverted,
            _a['Input--loading'] = !hideLoading,
            _a['Input--transparent'] = transparent,
            _a['Input--has-action'] = action,
            _a["Input--has-action-" + actionPosition] = action && actionPosition,
            _a['Input--has-icon'] = icon && !loadingOverlapsIcon,
            _a["Input--has-icon-" + iconPosition] = icon && iconPosition,
            _a['Input--has-addon'] = shortLabel,
            _a["Input--has-addon-" + shortLabelPosition] = shortLabel && shortLabelPosition,
            _a["InputGroup"] = action || icon || shortLabel,
            _a));
        var strictHtmlInputProps = inputProps_1.splitPropsUsingArray(inputProps, inputProps_1.htmlInputPropsArray)[0];
        var htmlInputProps = __assign(__assign({}, strictHtmlInputProps), { tabIndex: this.computeTabIndex(), onChange: this.handleChange, ref: this.inputRef });
        var _e = inputProps_1.splitPropsUsingArray(inputProps, __spreadArray(__spreadArray([], inputProps_1.htmlInputPropsArray), inputProps_1.inputPropsArray)), rest = _e[1];
        // Render with children
        if (Children.count(children) !== 0) {
            // Adding htmlInputProps to the `<input />` child...
            var childElements = Children.toArray(children).map(function (child) {
                if (child.type !== 'input') {
                    return child;
                }
                return cloneElement(child, _this.handleChildOverrides(child, htmlInputProps));
            });
            // Adding proper classes for special children (Button, Icon, InputAddon)...
            var childrenTypes_1 = Children.toArray(children)
                .map(function (c) {
                return (c.type.displayName || c.type.name || c.type).toString();
            })
                .map(function (type) { return (type === 'Input.Addon' ? 'InputAddon' : type); })
                .map(function (type) { return (type === 'ButtonGroup' ? 'Button' : type); });
            var compareChildrenOrder = function (c1, c2) {
                if (c2 === void 0) { c2 = 'input'; }
                if (childrenTypes_1.includes(c1) && childrenTypes_1.includes(c2)) {
                    return childrenTypes_1.indexOf(c1) < childrenTypes_1.indexOf(c2)
                        ? 'left'
                        : 'right';
                }
                return false;
            };
            InputClasses = classnames_1.default(InputClasses, (_b = {},
                _b["InputGroup"] = childrenTypes_1.length > 1,
                _b["Input--has-action Input--has-action-" + compareChildrenOrder('Button')] = compareChildrenOrder('Button'),
                _b["Input--has-addon Input--has-addon-" + compareChildrenOrder('InputAddon')] = compareChildrenOrder('InputAddon'),
                _b["Input--has-icon Input--has-icon-" + compareChildrenOrder('Icon')] = compareChildrenOrder('Icon'),
                _b));
            return (react_1.default.createElement(InputElement, __assign({}, rest, { className: InputClasses }), childElements));
        }
        // Render with shorthands
        return (react_1.default.createElement(InputElement, __assign({}, rest, { className: InputClasses }),
            actionPosition === 'left' && this.renderAction(),
            shortLabelPosition !== 'right' && this.renderShortLabel(),
            this.renderInput(htmlInputProps),
            this.renderIcon(),
            !hideLoading && react_1.default.createElement(__1.Spinner, null),
            shortLabelPosition === 'right' && this.renderShortLabel(),
            actionPosition !== 'left' && this.renderAction()));
    };
    Input.defaultProps = {
        actionPosition: 'right',
        el: 'div',
        iconPosition: 'right',
        shortLabelPosition: 'left',
        size: 'medium',
        type: 'text',
    };
    Input.Addon = InputAddon_1.InputAddon;
    Input.contextType = FormField_1.FormFieldContext;
    return Input;
}(react_1.default.Component));
exports.Input = Input;
//# sourceMappingURL=Input.js.map